module.exports = __webpack_public_path__ + "img/FloodOutlined.947ea614.svg";